import { t } from '@/i18n/utils'

/**
 * 搜索页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const searchCommonConfig = {
  texts: {
    get placeholder() { return t('SearchBox') },
    get cancel() { return t('Cancel') },
    get loading() { return `${t('Loading')}...` },
    get noResults() { return t('NoResult') },
    get startReading() { return t('StartReading') },
    get completed() { return t('Completed') },
    get ongoing() { return t('OnGoing') },
    get noMore() { return `${t('NoMore')} ~` },
  },
  colors: {
    inputBg: '#0000000A', // bg-b-light
  },
}
